import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table, TableSkeleton, TopProgress } from "../../../../../../components";
import { useAuth } from "../../../../../../context/user.context";
import { icons } from "../../../../../../icons";
import {Container} from './styles'
import { timeConverterMMDDYYHHMM } from "../../../../../../utils/dates";
import { useNavigate, useParams } from "react-router-dom";
import { useUi } from "../../../../../../context/ui.context";
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import { clientService } from "../../../../../../api";

const UserGroups:FC<any> = ({userGroups}) => {
  const {user, updateUser} = useAuth()
  const [pageLoading, setPageLoading] = useState<boolean>(false)
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam)
  const {viewAlert} = useUi()
  const [paginationData, setPaginationData] = useState<any>()
  const [t] = useTranslation()
  const {userId} = useParams()


  const navigate = useNavigate()
  const canDissociate = (id:any) => {
    
  }

  const items = [
    {
      title:t("EDIT"),
      id:'2',
      icon:icons.Edit,
      onClick: (item:any) => navigate(`${item.id}/client-edit`),
      divider:false
    },
    {
      title:t("DISSOCIATE"),
      id:'4',
      onClick:(item:any) => canDissociate(item.id),
      icon:icons.MinusDefault,
      divider:false
    },
  ]

  const columns = [
    {
      title:t("ID"),
      key:"id"
    },
    {
      title:t("NAME"),
      key:'long_name'
    },
    {
      title:t("YOUR_ROLES"),
      key:"roles",
      withBackground:true,
    },
    // {
    //   title:t("CREATED_AT"),
    //   key:"date_created"
    // },
    {
      title:"",
      key:'props'
    }
  ]
  return(
    <Container>
      {/* <TopProgress loading={pageLoading}/> */}
      <p>
        {t("USER_GROUPS")}
      </p>
      {pageLoading ?
        <TableSkeleton
            rows={10}
            columns={columns?.length || 5}
            columnsData={columns}
          />
      :
        <Table
          columns={columns}
          rows={userGroups}
          hideCheckbox
          settings={items}
          paginationData={paginationData}
          // updateData={updateList}
          loading={pageLoading}
        />
      }
    </Container>
  )
}

export default UserGroups
